import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade"; // Import fade effect CSS
import "./Header.css"; // Import custom CSS

import { Autoplay, EffectFade, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import React from "react";
import { assest } from "../../assest/assest";

const Header = () => {
  return (
    <div className="hero-container">
      {/* Left Side - Headings */}
      <div className="hero-text">
  <h1>Exposition</h1>
  <h2>Where Management Meets IT</h2>
  <p>
  Exposition, organized by the Industrial Management Science Students' Association at the University of Kelaniya, has long been a premier platform where Management and IT converge. With a rich legacy spanning over two decades, it fosters innovation, collaboration, and advancements across industries.  </p>
  <p>
Exposition Issue 20 bridges the evolving landscapes of technology and management, creating a space for in-depth discussions and impactful collaborations. By uniting thought leaders, industry professionals, and students, it sparks transformative ideas that shape the future of business and technology. This milestone edition empowers future leaders, challenges boundaries, and redefines possibilities while driving digital transformation forward.</p> 
  <button className="hero-button">Explore Now</button>
</div>



      {/* Right Side - Image Carousel */}
      <div className="hero-carousel">
        <Swiper
          modules={[Autoplay, Pagination, EffectFade]}
          effect="fade"
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          loop={true}
          className="swiper-container"
        >
          <SwiperSlide>
            <img src={assest.L4} alt="Slide 1" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={assest.L10} alt="Slide 2" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={assest.L2} alt="Slide 3" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={assest.L6} alt="Slide 3" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={assest.L9} alt="Slide 3" />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default Header;
